
import React from 'react';
import { Zap } from 'lucide-react';

interface AnalysisStatusProps {
  analysisStage: string;
}

export function AnalysisStatus({ analysisStage }: AnalysisStatusProps) {
  if (!analysisStage) return null;

  return (
    <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
      <div className="flex items-center gap-2 text-blue-700">
        <Zap className="h-4 w-4 animate-pulse" />
        <span className="font-medium">Analysis in Progress</span>
      </div>
      <p className="text-sm text-blue-600 mt-1">{analysisStage}</p>
    </div>
  );
}
